<template>
  <div>
    <meu-menu></meu-menu>
    <b-container fluid class="adjustment-margin">
      <!-- Card vagas encaminhadas -->
      <b-row class="card-style">
        <b-col
          lg="4"
          md="4"
          sm="12"
          xs="12"
          v-for="rows in this.vagasEncaminhadas"
          :key="rows.id"
          :class="status[rows.status.id].cor"
        >
          <div class="card-main-vagas-encaminhadas adjustment-margin">
            <div>
              <h5 class="titulo-vagas">{{ rows.cargo }}</h5>
              <h6>
                <b-badge pill :variant="status[rows.status.id].cor">{{
                  status[rows.status.id].nome
                }}</b-badge>
              </h6>
              <h6 class="subtitulo-vagas">
                Data de encaminhamento:
                <span class="text-primary">{{ rows.data_incluido }}</span>
              </h6>
              <h6 class="texto-vagas">Status: {{ rows.status.nome }}</h6>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Paginador -->
      <b-row>
        <b-col cols="12" col lg="4" sm="12" md="2" class="paginatorWrapper">
          <div class="paginator-margin">
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              align="center"
              pills
              size="lg"
              hide-goto-end-buttons
              aria-controls="my-table"
              @input="getData(currentPage)"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { sharedService } from "../../services";
import Menu from "../shared/Menu";
export default {
  data() {
    return {
      vagasEncaminhadas: [],
      perPage: 6,
      total: 0,
      areas: [],
      currentPage: 1,
      status: [
        { cor: "info", nome: "Aguardando" },
        { cor: "danger", nome: "Reprovado" },
        { cor: "success", nome: "Aprovado" },
        { cor: "dark", nome: "Fechou Vaga" },
      ],
    };
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
  },
  components: {
    "meu-menu": Menu,
  },
  methods: {
    detalhesVaga(item) {
      this.$router.push({
        name: "VagasAreasEdit",
        params: { nome: item },
      });
    },
    getArea: async function () {
      let self = this;
      await sharedService
        .read("VagasPorArea/" + this.$store.getters.getApiKey)
        .then(function (obj) {
          self.areas = obj.obj;
        });
    },
    sairConta() {
      this.$store.dispatch("setSair");
      this.usuarioDados.id = 0;
      this.usuarioDados.nome = "";
    },
    getData: async function (pageNum) {
      let self = this;

      if (pageNum === undefined) {
        pageNum = 1;
      }

      await sharedService
        .read(
          "Candidato/vaga/" +
            this.$store.getters.getApiKey +
            "?limit=" +
            self.perPage +
            "&page=" +
            pageNum +
            "&order=data_incluido%20desc"
        )
        .then(function (obj) {
          self.vagasEncaminhadas = obj.obj;
          self.currentPage = obj.page;
          self.total = parseInt(obj.total_records, 0);
        });
    },
    voltar() {
      this.$router.push({
        name: "ultimas",
      });
    },
    cadastro() {
      this.$router.push({
        name: "Cadastro",
      });
    },
  },
  beforeMount() {
    this.getData();
    this.getArea();
    this.usuarioDados = this.$store.getters.getUser;
  },
  watch: {
    user: function () {
      if (this.user.id !== 0) {
        this.usuarioDados = this.user;
      }
    },
  },
};
</script>
<style>
.titulo-vagas {
  color: var(--card-title-color);
  font-weight: bold;
  line-height: 1.2;
  text-transform: uppercase;
}

.subtitulo-vagas {
  color: var(--card-subtitle-color);
  font-weight: 700;
  line-height: 1.2;
}

.texto-vagas {
  color: var(--card-text-color);
}

.card-style {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.paginatorWrapper {
  width: 25vw;
  padding: 0;
  margin: 0 auto !important;
}

.paginator-margin {
  margin: 3ch 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
